import React from "react";
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';

export const CustomPagination = ({ currentPage, totalPages, onPageChange }) => {

    const calculatePageNumber = (position) => {
        if (currentPage) {
            const isNearStart = currentPage <= 3;
            const isNearEnd = currentPage + 2 >= totalPages;
            let page;

            if (isNearStart) {
                page = position;
            } else if (isNearEnd) {
                page = totalPages - (5 - position);
            } else {
                page = currentPage + (position - 3);
            }
            return totalPages > 5 ? page : position;
        }
    }

    return <Pagination className="mt-auto pt-3" cssModule={{ 'pagination': 'pagination justify-content-center align-items-center' }}>
        <PaginationItem disabled={(currentPage === 1)}>
            <PaginationLink previous onClick={() => onPageChange(currentPage - 1)}><FontAwesomeIcon icon={faChevronLeft} /></PaginationLink>
        </PaginationItem>

        {currentPage > 3 && totalPages > 5 && <>
            <PaginationItem> <PaginationLink onClick={() => onPageChange(1)}> {1} </PaginationLink></PaginationItem>
            <PaginationItem> <PaginationLink > ... </PaginationLink></PaginationItem>
        </>
        }

        {calculatePageNumber(1) <= totalPages && <PaginationItem disabled={calculatePageNumber(1) > totalPages} active={(currentPage === calculatePageNumber(1))}>  <PaginationLink onClick={() => onPageChange(calculatePageNumber(1))}>   {calculatePageNumber(1)}  </PaginationLink></PaginationItem>}
        {calculatePageNumber(2) <= totalPages && <PaginationItem disabled={calculatePageNumber(2) > totalPages} active={(currentPage === calculatePageNumber(2))}>  <PaginationLink onClick={() => onPageChange(calculatePageNumber(2))}>   {calculatePageNumber(2)}  </PaginationLink></PaginationItem>}
        {calculatePageNumber(3) <= totalPages && <PaginationItem disabled={calculatePageNumber(3) > totalPages} active={(currentPage === calculatePageNumber(3))}>  <PaginationLink onClick={() => onPageChange(calculatePageNumber(3))}>   {calculatePageNumber(3)}  </PaginationLink></PaginationItem>}
        {calculatePageNumber(4) <= totalPages && <PaginationItem disabled={calculatePageNumber(4) > totalPages} active={(currentPage === calculatePageNumber(4))}>  <PaginationLink onClick={() => onPageChange(calculatePageNumber(4))}>   {calculatePageNumber(4)}  </PaginationLink></PaginationItem>}
        {calculatePageNumber(5) <= totalPages && <PaginationItem disabled={calculatePageNumber(5) > totalPages} active={(currentPage === calculatePageNumber(5))}>  <PaginationLink onClick={() => onPageChange(calculatePageNumber(5))}>   {calculatePageNumber(5)}  </PaginationLink></PaginationItem>}

        {calculatePageNumber(5) + 1 <= totalPages && <>
            <PaginationItem> <PaginationLink > ... </PaginationLink></PaginationItem>
            <PaginationItem> <PaginationLink onClick={() => onPageChange(totalPages)}> {totalPages} </PaginationLink></PaginationItem>
        </>
        }

        <PaginationItem disabled={(currentPage === totalPages)} ><PaginationLink next onClick={() => onPageChange(currentPage + 1)}><FontAwesomeIcon icon={faChevronRight} /></PaginationLink></PaginationItem>
    </Pagination>
}